import axios from "@/axios/index.js";
import {
  setConnectedUser,
  setCurrentSession,
  setGuardSystem,
} from "@/utils/localStorage";
import { makeRequest, noAuthRequest } from "@/services/index";
import router from "@/router/index";

export async function getInitialInfos(credentians) {
  return await noAuthRequest("POST", "validCredentials", credentians);
}

export async function setLogin(userLogin) {
  let checkUserLogged = {};

  await axios({
    method: "POST",
    url: "/login",
    data: userLogin,
  })
    .then(async (response) => {
      localStorage.setItem("sessionToken", response.data.token);

      await axios({
        method: "GET",
        url: "/auth/me",
      }).then((authResponse) => {
        setConnectedUser({ ...authResponse.data, checkLogin: true });
        setCurrentSession();
        setGuardSystem();
      });

      checkUserLogged = { status: true, message: response.data.message };
    })
    .catch((error) => {
      checkUserLogged = { status: false, message: error };
    });

  return checkUserLogged;
}

export function setLogout() {
  router.push({ path: "/" });
  localStorage.clear();

  axios({
    method: "POST",
    url: "/auth/logout",
  }).then(() => {});
}

export async function createUser(user) {
  return await makeRequest("POST", "users", user);
}

export async function updateUser(id, user) {
  return await makeRequest("PUT", `/users/${id}`, user);
}

export async function getUsersByUnity(filters) {
  return await makeRequest("GET", "/users/get/namePerProfile", null, filters);
}

export async function getUsersWithFilters(filters) {
  return await makeRequest("GET", "/users", null, filters);
}

export async function getUserDetails(id) {
  return await makeRequest("GET", `/users/${id}`);
}

export async function getUserUnitiesAndProfiles(id) {
  return await makeRequest("GET", `users/get/userUnityProfile/${id}`);
}

export async function changeUserUnityProfiles(id, data) {
  return await makeRequest("POST", `users/link/userUnityProfile/${id}`, data);
}

export async function removeUserUnityProfiles(id) {
  return await makeRequest("DELETE", `users/remove/userUnityProfile/${id}`);
}
